export class BreakdownAddress {
  address1 = '';
  address2 = '';
  address3 = '';
  address4 = '';
  county = '';
  postcode = '';
}
